import { useEffect, useState } from "react";

const DESKTOP_FORM_BREAKPOINT = 768;
const PORTRAIT_TABLET_QUERY = "(min-width: 769px) and (max-width: 1024px) and (orientation: portrait)";

function isPortraitTablet() {
  return typeof window !== "undefined" && window.matchMedia?.(PORTRAIT_TABLET_QUERY).matches;
}

function getPresentation() {
  if (typeof window === "undefined") return "sheet";
  if (isPortraitTablet()) return "sheet";
  return window.innerWidth >= DESKTOP_FORM_BREAKPOINT ? "modal" : "sheet";
}

export default function useFormPresentation() {
  const [presentation, setPresentation] = useState(getPresentation);

  useEffect(() => {
    const update = () => setPresentation(getPresentation());
    const portraitTablet = window.matchMedia?.(PORTRAIT_TABLET_QUERY);
    update();
    window.addEventListener("resize", update);
    portraitTablet?.addEventListener?.("change", update);
    return () => {
      window.removeEventListener("resize", update);
      portraitTablet?.removeEventListener?.("change", update);
    };
  }, []);

  return presentation;
}
